module.exports = __webpack_public_path__ + "img/slide-17.3ff5d5c9.jpg";